var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey',{attrs:{"survey":_vm.survey,"isExpanded":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }